import { createSelector } from 'reselect'

import { getApp, getUser } from '@/common/selectors'

export default createSelector([getUser, getApp], (user, app) => ({
  authorized: user.isAuthorized,
  language: user.language,
  countries: app.countries,
  isCountriesLoading: app.isCountriesLoading,
}))
